import type { StateSchema } from '@/app/providers/storeProvider';
import { initialState } from '../../const/initialState';

export const getSkipRefreshToken = (state: StateSchema) => state.auth?.skipRefresh ?? initialState.skipRefresh;
